import { TableCategory } from './tableCategory.types';
import { TransportAssignmentStatus } from './transportAssignment.types';
import { LocationValue } from '../sharedComponents/filter/LocationFilter';
import { MeansOfTransportType, VehicleType } from '../sharedComponents/common.types';
import { TransportAssignmentFilterParams } from '../api/transportOrderApi';
import { mapCategoryToFilterableStatus } from './transportAssignmentsQuery';
import { TransportAssignmentSearchMode } from '../reducers/transportAssignmentsSlice';
import { parseUniqueEntries } from '../sharedComponents/inputListParser';

export interface ModalFilters {
    startDateFilter: Date | undefined;
    endDateFilter: Date | undefined;
    pickUpLocation: LocationValue;
    deliveryLocation: LocationValue;
    meansOfTransportTypeFilter: MeansOfTransportType | undefined;
    vehicleTypeFilter: VehicleType | undefined;
    manufacturerFilter: string | undefined;
}

export type Filters = {
    modalFilters: ModalFilters;
    statusFilter: TransportAssignmentStatus[];
    category: TableCategory;
};

export const mapFilterToQueryParam = (filters: Filters): TransportAssignmentFilterParams => ({
    statuses: mapCategoryToFilterableStatus(filters.statusFilter, filters.category),
    requestedPickUpFrom: filters.modalFilters?.startDateFilter,
    requestedPickUpTo: filters.modalFilters?.endDateFilter,
    loadingLocation: filters.modalFilters?.pickUpLocation,
    unloadingLocation: filters.modalFilters?.deliveryLocation,
    vehicleType: filters.modalFilters?.vehicleTypeFilter,
    manufacturer: filters.modalFilters?.manufacturerFilter,
    meansOfTransportType: filters.modalFilters?.meansOfTransportTypeFilter,
    archived: filters.category === TableCategory.ARCHIVE,
});

export const mapSearchValueToQueryParam = (
    searchMode: TransportAssignmentSearchMode,
    searchValue: string,
): TransportAssignmentFilterParams => {
    const trimmedValue = searchValue.trim();

    if (trimmedValue.length === 0) {
        return {};
    }

    switch (searchMode) {
        case TransportAssignmentSearchMode.VIN: {
            const vins = parseUniqueEntries(trimmedValue);
            return vins.length > 0 ? { vins } : {};
        }
        case TransportAssignmentSearchMode.MEANS_OF_TRANSPORT_ID:
            return { meansOfTransportId: trimmedValue };
        case TransportAssignmentSearchMode.BUNDLE_ID:
            return { bundleId: trimmedValue };
        case TransportAssignmentSearchMode.EXTERNAL_ORDER_ID:
            return { externalOrderId: trimmedValue };
    }
};
